import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { IncomingEInvoiceMatchingQueueContainerModel } from '../../../../../models/aggregates/e-invoice/bl_fi_incoming_einvoice_matching_queue_container.model';
import { ApiResponseModel, ApiVisa } from '../../../..';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class IncomingEInvoiceMatchingQueueService extends BaseApiTemplateService<IncomingEInvoiceMatchingQueueContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/incoming-einvoice-matching-queues/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/incoming-einvoice-matching-queues/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/incoming-einvoice-matching-queues/backoffice-ep'
    this.httpClient = http;
  }

  matchManually(incoming_matching_queue_guid: string, purchase_doc_matching_queue_guid: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + `e-invoice/incoming-einvoice-matching-queues/manual-matching/backoffice-ep?incoming_matching_queue_guid=${incoming_matching_queue_guid}&purchase_doc_matching_queue_guid=${purchase_doc_matching_queue_guid}`
    }
  
    const httpOptions = this.getHttpHeader(visa);
  
    httpOptions.headers = httpOptions.headers.set('Content-Type', 'application/json');
  
    return this.httpClient.get<ApiResponseModel<any>>(
      customUrl,
      httpOptions
    );
  }

  processNow(visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
        // Get the headers from getHttpHeader
        const httpOptions = this.getHttpHeader(visa);
        // Add the Content-Type header
        httpOptions.headers = httpOptions.headers.set('Content-Type', 'application/json');
        
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + 'incoming-einvoice-matching-queues/process/execute/backoffice-ep'
    }
    return this.httpClient.get<ApiResponseModel<any>>(
      customUrl,
      httpOptions
    );
  }
}
